import launch from '@/views/launch'
import launchControl from '@/views/launch/control'
import launchControlList from '@/views/launch/control/list'
import launchControlPayment from '@/views/launch/control/payment'
import launchControlReservation from '@/views/launch/control/reservation'
import launchControlValidation from '@/views/launch/control/validation'
import launchManagement from '@/views/launch/management'
import launchComputerServicePoint from '@/views/launch/management/computer-service-point'
import launchCreate from '@/views/launch/management/create'
import launchCommissioning from '@/views/launch/management/create/components/launch-commissioning'
import launchMainData from '@/views/launch/management/create/components/launch-create-main-data'
import launchBoxOperators from '@/views/launch/management/create/components/launch-operators-box'
import launchPaymentMethods from '@/views/launch/management/create/components/launch-payment-methods'
import launchPaymentPlans from '@/views/launch/management/create/components/launch-payment-plans'
import launchServicePoints from '@/views/launch/management/create/components/launch-services-points'
import launchList from '@/views/launch/management/list'
import launchCustomerCall from '@/views/launch/control/display'

import { storage } from '@/services/storage'


const routes = [
	{
		path: '/lancamentos',
		name: 'launch',
		component: launch,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Lançamentos',
			protect: true,
		},
		redirect: { name: 'launch.management.list' },
		children: [
			{
				path: 'gerenciamento',
				name: 'launch.management',
				component: launchManagement,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lançamentos',
					protect: true,
				},
				redirect: { name: 'launch.management.list' },
				children: [
					{
						path: 'controle-ponto-atendimento',
						name: 'launch.management.computerServicePoint',
						component: launchComputerServicePoint,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle Ponto Atendimento',
							protect: true,
						},
					},
					{
						path: 'listar',
						name: 'launch.management.list',
						component: launchList,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Listar Lançamentos',
							protect: true,
						},
					},
					{
						path: 'criar',
						name: 'launch.management.create',
						component: launchCreate,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Criar Lançamentos',
							protect: true,
						},
						redirect: { name: 'launch.management.create.mainData' },
						children: [
							{
								path: 'dados-principais',
								name: 'launch.management.create.mainData',
								component: launchMainData,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Dados Principais',
									protect: true,
								},
							},
							{
								path: 'pontos-de-atendimento',
								name: 'launch.management.create.servicePoints',
								component: launchServicePoints,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Pontos de Atendimento',
									protect: true,
								},
							},
							{
								path: 'operadores-de-caixa',
								name: 'launch.management.create.boxOperators',
								component: launchBoxOperators,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Operadores de Caixa',
									protect: true,
								},
							},
							{
								path: 'formas-de-pagamento',
								name: 'launch.management.create.paymentMethods',
								component: launchPaymentMethods,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Formas de Pagamento',
									protect: true,
								},
							},
							{
								path: 'planos-de-pagamento',
								name: 'launch.management.create.paymentPlans',
								component: launchPaymentPlans,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Planos de Pagamento',
									protect: true,
								},
							},
							{
								path: 'comissionamento',
								name: 'launch.management.create.commissioning',
								component: launchCommissioning,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Comissionamento',
									protect: true,
								},
							}
						]
					}
				]
			},
			{
				path: 'controle',
				name: 'launch.control',
				component: launchControl,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Controle de Lançamento',
					protect: true,
				},
				redirect: { name: 'launch.control.called' },
				children: [
					{
						path: 'chamado',
						name: 'launch.control.called',
						component: launchControlList,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle de Chamado',
							protect: true,
						},
					},
					{
						path: 'credenciamento',
						name: 'launch.control.accreditation',
						component: launchControlList,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle de Credenciamento',
							protect: true,
						},
					},
					{
						path: 'reserva',
						name: 'launch.control.reservation',
						component: launchControlReservation,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle de Reserva',
							protect: true,
						},
					},
					{
						path: 'validacao',
						name: 'launch.control.validation',
						component: launchControlValidation,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle de Validation',
							protect: true,
						},
					},
					{
						path: 'pagamento',
						name: 'launch.control.payment',
						component: launchControlPayment,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Controle de Pagamento',
							protect: true,
						},
					},
					{
						path: 'chamada-de-clientes',
						name: 'launch.control.customer_call',
						component: launchCustomerCall,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Chamada de Clientes',
							protect: true,
						},
					}
				]
			},
		]
	}
]

export { routes }

